
import React from 'react';

import { Goonj2025 } from '../views';

const SchoolProgrampage = () => {
  return <Goonj2025 />;
};

export default SchoolProgrampage;